import { Injectable } from '@angular/core';
import {fromEvent, Observable } from 'rxjs';
import { TusUploadProgress } from './tus-upload-progress';
import * as tus from 'tus-js-client';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {ConfigService} from '@docma-mm-core/config/config.service';
import { HttpHeaders } from '@angular/common/http';
import {joinUrl} from '@docma-mm-core/utils/utils';
import {UploadOptions} from 'tus-js-client';

@Injectable({
  providedIn: 'root'
})
export class TusUploadService {

  constructor(private readonly configService: ConfigService) {
  }

  uploadFile(file: File): Observable<TusUploadProgress> {
    const endpoint = joinUrl(this.configService.getMmConfig().apiUrl, 'files');

    return new Observable<TusUploadProgress>(observer => {
      let upload: tus.Upload;

      const startUpload = () => {
        upload = new tus.Upload(file, {
          endpoint,
          chunkSize: 2 * 1024 * 1024,
          parallelUploads: 1,
          retryDelays: [0, 3000, 5000, 10000], // retries on failure
          metadata: { filename: file.name, filetype: file.type },
          storeFingerprintForResuming: true,

          onError: (err: any) => {
            console.warn('Upload error:', err);
            observer.next({ uploaded: 0, total: file.size, percentage: 0, error: err });
            // Do NOT complete yet. Wait for network reconnect to resume.
          },

          onProgress: (uploaded, total) => {
            const percentage = Math.round((uploaded / total) * 100);
            observer.next({ uploaded, total, percentage });
          },

          onSuccess: () => {
            observer.next({ uploaded: file.size, total: file.size, percentage: 100, url: upload.url, finished: true });
            observer.complete();
          }
        });

        console.warn('tus start (1)');
        upload.start();
      };

      console.warn('tus start (0)');
      startUpload();

      // Listen for online event to resume automatically
      const online$ = fromEvent(window, 'online');
      const subscription = online$.subscribe(() => {
        if (upload) {
          console.log('Network reconnected, trying to resume upload...');
          upload.start(); // tus-js-client will resume automatically
        }
      });

      // Cleanup on unsubscribe
      return () => {
        if (upload) {
          upload.abort();
        } // pause for resume
        subscription.unsubscribe();
      };
    });
  }

}
